import template from "../../components/info-window/info-window.template.html";

import _ from 'lodash';

export class DesignViewController {

    constructor($log, $rootScope, UserSessionService, ProductDataService, PreviewWindowService, $uibModal, $stateParams) {
        'ngInject';

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.userSessionService = UserSessionService;
        this.productDataService = ProductDataService;
        this.previewWindowService = PreviewWindowService;
        this.$uibModal = $uibModal;

        this.$log.debug($stateParams);

    }

    $onInit() {

        this.$log.debug('DesignViewController::$onInit', this.appStates);

        this.optionSets = [];

        this.selectedDoor = this.userSessionService.getSelectedDoor();
        if (this.selectedDoor.getProduct() === null) this.openProductsMenu();

        this.initListeners();

        //this.renderImage();

    }

    initListeners() {

        this.selectedDoorUpdatedDereg = this.$rootScope.$on('UserSessionService::selectedDoorUpdated', () => {
            this.closeAllMenus();
            this.selectedDoor = this.userSessionService.getSelectedDoor();
            if (this.selectedDoor.getProduct() === null) this.openProductsMenu();
        });

    }

    $onDestroy() {
        this.selectedDoorUpdatedDereg();
    }

    getDisableOptionMenuDone() {
        return this.selectedDoor.getProduct() === null;
    }

    getImage() {
        return this.userSessionService.getImage();
    }

    getDoors() {
        return this.userSessionService.getDoors();
    }

    getOptionSets() {
        return this.optionSets;
    }

    getSelections() {
        return this.selectedDoor.getSelections();
    }

    getSelectedDoor() {
        return this.selectedDoor;
    }

    openDoorPreview() {
        this.$log.debug('DesignViewController::openDoorPreview', this.selectedDoor);
        this.previewWindowService.open(this.selectedDoor.getType(), this.selectedDoor.getPreview());
    }

    selectItem(item) {

        this.$log.debug('DesignViewController::selectItem', item);

        if (item.type === 'product') {
            this.openProductsMenu();
            return;
        }

        if (item.type === 'profile') {
            this.openProfilesMenu();
            return;
        }

        if (item.type === 'colour_range') {
            this.openColourRangesMenu();
            return;
        }

        if (item.type === 'colour') {
            this.openColoursMenu();
            return;
        }

        if (item.type === 'option') {
            this.openOptionValuesMenu(item.parent);
            return;
        }

        if (item.type === 'sub_option') {
            this.openSubOptionValuesMenu(item.parent);
            return;
        }

        if (item.type === 'sub_option_colour') {
            this.openSubOptionColoursMenu(item.parent);
            return;
        }

    }

    selectOption(option) {

        this.$log.debug('DesignViewController::selectOption', option);

        if (option.type === 'product') {
            this.selectedDoor.setProduct(option.data);
            //this.openNotes(this.selectedDoor.getProfile());
            this.openProfilesMenu();
            this.renderImage();
            return;
        }

        if (option.type === 'profile') {
           // this.openNotes(option.data);
            this.selectedDoor.setProfile(option.data);
            this.renderImage();
            return;
        }

        if (option.type === 'colour_range') {
            this.selectedDoor.setColourRange(option.data);
            this.openColoursMenu();
            this.renderImage();
            return;
        }

        if (option.type === 'colour') {
            this.selectedDoor.setColour(option.data);
            this.renderImage();
            return;
        }

        if (option.type === 'option') {
            this.selectedDoor.setOptionValue(option.parent, option.data);
            this.renderImage();

            return;
        }

        if (option.type === 'sub_option') {
            this.selectedDoor.setSubOptionValue(option.parent, option.data);
            this.renderImage();
            return;
        }

        if (option.type === 'sub_option_colour') {
            this.selectedDoor.setSubOptionColourValue(option.parent, option.data);
            this.renderImage();
            return;
        }

    }

    closeMenu() {

        this.$log.debug('DesignViewController::closeMenu');

        this.optionSets.pop();

    }

    closeAllMenus() {

        this.$log.debug('DesignViewController::closeAllMenus');

        this.optionSets.length = 0;

    }

    openProductsMenu() {

        this.optionSets.push(
            {
                title: 'Select a product',
                options: _.map(this.productDataService.getProducts(), (product) => {
                    return {
                        id: product.id,
                        label: product.label,
                        type: 'product',
                        data: product,
                        info: product.info
                    };
                }),
                selectedOption: this.selectedDoor.getProduct(),
                disableDone: this.getDisableOptionMenuDone(),
                disableBack: this.getDisableOptionMenuDone()
            }
        );

    }

    openProfilesMenu() {

        let profiles = this.productDataService.getProductProfiles(this.selectedDoor.getProduct().id, this.selectedDoor.getType());

        if (profiles.length > 1) {

            this.optionSets.push(
                {
                    title: 'Select a profile',
                    options: _.map(profiles, (profile) => {
                        return {
                            id: profile.id,
                            label: profile.label,
                            size_info: profile.size_info,
                            type: 'profile',
                            data: profile,
                            info: profile.info
                        };
                    }),
                    selectedOption: this.selectedDoor.getProfile(),
                    disableDone: this.getDisableOptionMenuDone(),
                }
            );

        } else {
            this.closeMenu();
        }
    }

    openColourRangesMenu() {

        let colourRanges = this.productDataService.getProfileColourRanges(this.selectedDoor.getProfile().id);

        if (colourRanges.length > 1) {

            this.optionSets.push(
                {
                    title: 'Select a colour range',
                    options: _.map(colourRanges, (colourRange) => {
                        return {
                            id: colourRange.id,
                            label: colourRange.label,
                            type: 'colour_range',
                            data: colourRange,
                            info: colourRange.info
                        };
                    }),
                    selectedOption: this.selectedDoor.getColourRange(),
                    disableDone: this.getDisableOptionMenuDone(),
                }
            );

        }
    }

    openColoursMenu() {

        let colours = this.productDataService.getColourRangeColours(this.selectedDoor.getColourRange().id);

        this.optionSets.push(
            {
                title: 'Select a colour',
                options: _.map(colours, (colour) => {
                    return {
                        id: colour.id,
                        label: colour.label,
                        type: 'colour',
                        data: colour,
                        info: colour.info
                    };
                }),
                selectedOption: this.selectedDoor.getColour(),
                disableDone: this.getDisableOptionMenuDone(),
            }
        );
    }

    openOptionValuesMenu(option) {

        this.$log.debug('DesignViewController::openOptionValuesMenu', option);

        if (option.values.length > 1) {

            this.optionSets.push(
                {
                    title: option.label,
                    options: _.map(option.values, (value) => {
                        return {
                            id: value.id,
                            label: value.label,
                            type: 'option',
                            data: value,
                            parent: option,
                            info: option.info
                        };
                    }),
                    selectedOption: this.selectedDoor.getOptionValue(option),
                    disableDone: this.getDisableOptionMenuDone(),
                }
            );
        }

    }

    openSubOptionValuesMenu(option) {

        this.$log.debug('DesignViewController::openSubOptionValuesMenu', option);

        if (option.values.length > 1) {


            this.optionSets.push(
                {
                    title: option.label,
                    options: _.reduce(option.values, (options, value) => {

                        if (value[this.selectedDoor.getType() + '_asset']) {
                            options.push({
                                id: value.id,
                                label: value.label,
                                type: 'sub_option',
                                data: value,
                                parent: option,
                                info: value.info
                            });
                        }

                        return options;

                    }, []),
                    selectedOption: this.selectedDoor.getSubOptionValue(option),
                    disableDone: this.getDisableOptionMenuDone(),
                }
            );

        }

    }

    openSubOptionColoursMenu(option) {

        this.$log.debug('DesignViewController::openSubOptionColoursMenu', option);

        if (option.colours.length > 1) {

            this.optionSets.push(
                {
                    title: option.label,
                    options: _.map(option.colours, (colour) => {
                        return {
                            id: colour.id,
                            label: colour.label,
                            type: 'sub_option_colour',
                            data: colour,
                            parent: option
                        };
                    }),
                    selectedOption: this.selectedDoor.getSubOptionColour(option),
                    disableDone: this.getDisableOptionMenuDone(),
                }
            );
        }

    }

    renderImage() {
        this.userSessionService.renderImage();
    }

    openNotes(data) {

        if (!data.info) return;

        let title = data.label;
        let body = data.info;

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            resolve: {
                data: () => {
                    return {
                        title: title,
                        body: body
                    };
                }
            },
            controller: function($sce, data) {
                'ngInject';

                this.title = data.title;
                this.body = $sce.trustAsHtml(data.body);
            },
            controllerAs: '$ctrl'
        });

        modalInstance.result.then(() => {

        }, () => {

        });

    }

}



// WEBPACK FOOTER //
// ./src/js/views/design-view/design-view.controller.js